export default __webpack_public_path__ + "static/media/about17.d13db8ed.jpeg";